import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'lib-input-label',
    standalone: true,
    imports: [TranslateModule, TooltipModule],
    styles: [
        `
            .semibold {
                font-weight: 600;
            }
        `
    ],
    template: `
        @if (field.label && field.inputType !== 'checkbox' && field.inputType !== 'fieldset') {
        <label for="{{ 'input' + name }}" class="label semibold" [class]="field.labelClass.join(' ')"
            >{{ field.label | translate }} @if (field.required) {
            <span>*</span>
            } @if (field.infoButtonText) {
            <i
                class="pi pi-info-circle info-icon"
                [pTooltip]="field.infoButtonText | translate"
                tooltipPosition="right"
            ></i>
            }
        </label>
        }
    `
})
export class InputLabelComponent {
    @Input() name!: string;
    @Input() field!: any;
    @Input() filter!: boolean;
}
